import { useRecord } from "@latticexyz/stash/react";
import mudConfig from "contracts/mud.config";
import { stash } from "../../../mud/stash";
import { useSessionPlayer } from "../../../SessionPlayerContext";

import ButtonStyleText from "../../../components/ButtonStyleText";
import { factionNames } from "../../../config";

export const FangoUI = () => {
  const { address: userAddress } = useSessionPlayer();

  const player = (userAddress) ? useRecord({
    stash, 
    table: mudConfig.tables.Player, 
    key: { counterValue: userAddress } 
  }) : false;

  const factionName = (player) ? useRecord({
      stash, 
      table: mudConfig.tables.Fraction, 
      key: { counterValue: player.fraction } 
    })?.fractionName : false;

  return <>
    <ButtonStyleText text={`${player.name}, a ${factionNames[factionName]}`} />      
  </>
}